<template>
  <div class="app-coin-input">
    <div class="v-input v-text-field v-input--has-state v-input--is-label-active v-input--is-dirty theme--light" :class="{ 'v-input--is-focused': focused, 'secondary--text': focused, 'error--text': hasError, 'v-input--is-disabled': disabled }">
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-text-field__slot">
            <label 
              :class="{ 
                'required-field': isRequired && !hideRequired, 
                'secondary--text': focused, 
                'error--text': hasError 
              }"
              aria-hidden="true" 
              class="v-label v-label--active theme--light" 
            >
              {{ label }}
            </label>
            <money
              v-bind="config"
              :value="value"
              :disabled="disabled"
              @input="input"
              @blur.native="blur"
              @focus.native="focus"
              @keydown.native="keydown"
              @focusout.native="focusout" />
          </div>
        </div>
        <div 
          v-if="currentError"
          class="v-text-field__details" 
        >
          <div 
            :class="{ 'error--text': hasError }"
            class="v-messages theme--light" 
          >
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                {{ currentError }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCoinInput',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    v: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    blockNegativeValues: {
      type: Boolean,
      default: false
    },
    numberValueOnBlur: {
      type: Boolean,
      default: false
    },
    hideRequired: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    config: {
      decimal: '.',
      thousands: '.',
      prefix: '',
      precision: 0
    },
    focused: false
  }),
  computed: {
    hasError () {
      return !!this.currentError
    },
    currentError () {
      return this.$formErrors(this.v)[0]
    },
    isRequired () {
      return this.v
        // eslint-disable-next-line no-prototype-builtins
        ? this.v.hasOwnProperty('required')
        : false
    }
  },
  methods: {
    input (value) {
      this.inputValue = value
      this.$emit('input', value)
    },
    blur ({ target: { value } }) {
      if (this.v) this.v.$touch()

      if (this.numberValueOnBlur) {
        this.$emit('blur', this.inputValue)
        return;
      }

      this.$emit('blur', value)
    },
    focus () {
      this.focused = true
    },
    focusout () {
      this.focused = false
    },
    keydown($e) {
      $e.key === '-' && this.blockNegativeValues ? $e.preventDefault() : null
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-label
    left: 0px
    right: auto
    position: absolute
</style>
